<div [ngClass]="{'quick-add-wrap':!isModal}" class="">
  <h3 *ngIf="!isModal" class="title">
    {{"HOME_QUICK_ADD" | translate}}
  </h3>
  <div class="quick-add__tabs add_menu my-6 mx:flex">
    <div class="lx:w-[1336px] sm:w-full md:w-[1000px]">
      <nz-tabset class="mx:!block w-full" [nzSelectedIndex]="tabSelectedIndex" [nzTabBarExtraContent]="extraTemplate"
        (nzSelectedIndexChange)="onTabChange($event)">
        <nz-tab [nzTitle]="'ADD_MULTIPLE'|translate">
          <app-multiple-line [isModal]="isModal" (closeModal)="closeAddModal()"
            (canAdd)="setIsValid($event)"></app-multiple-line>
        </nz-tab>
        <nz-tab [nzTitle]="'ADD_COPY'|translate">
          <ng-template nz-tab>
            <app-copy-paste [isModal]="isModal" (closeModal)="closeAddModal()"
              (canAdd)="setIsValid($event)"></app-copy-paste>
          </ng-template>
        </nz-tab>
        <nz-tab [nzTitle]="'ADD_CSV'|translate">
          <ng-template nz-tab>
            <app-csv-excel [isModal]="isModal" (closeModal)="closeAddModal()"
              (canAdd)="setIsValid($event)"></app-csv-excel>
          </ng-template>
        </nz-tab>
      </nz-tabset>

    </div>

    <ng-template #extraTemplate>
        <div class="primary-mid-btn add-cart mx:w-[200px] sm:w-full" [ngClass]="{ 'disabled': isValid}"
        (click)="addToCart()">
        <svg-icon [isUrl]="false" [iconName]="'new/cart.svg'" class="mr-2"></svg-icon>
        <span>{{"ADD_TO_CART" | translate}}</span>
      </div>
      
    </ng-template>

  </div>
</div>